import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ProcessingFeeModalUI from './ProcessingFeeModalUI.js'

class ProcessingFeeModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      processingFeeFromLoan: this.props.loan.termSheet.processingFeeFromLoan ? 'true' : 'false',
      processingFeeFromLoanError:null
    }
  }

  render() {
    let booleanList = [
      { key: 'true', value: 'Yes' },
      { key: 'false', value: 'No' },
    ]
    return (
      <ProcessingFeeModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        processingFeeFromLoan={this.state.processingFeeFromLoan}
        onProcessingFeeFromLoanChange={(event) => { this.setState({ processingFeeFromLoan: event.target.value }) }}
        processingFeeFromLoanError={this.state.processingFeeFromLoanError}
        booleanList={booleanList}

      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/processingFeeSource`,
      this.onSubmitCallback,
      {
        processingFeeFromLoan: this.state.processingFeeFromLoan
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      this.props.onRefreshClick('noBusy')
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(ProcessingFeeModalSF)
